/**
 * @fileoverview Component that dynamically loads highlight.js themes based on
 * the current MUI color scheme (light/dark mode).
 */

import { useEffect } from 'react';
import { useColorScheme } from '@mui/material';

export function HighlightThemeProvider(): null {
  const { mode } = useColorScheme() || { mode: 'light' };

  useEffect(() => {
    // Remove any existing highlight.js stylesheets
    const existingLinks = document.querySelectorAll('link[data-highlight-theme]');
    existingLinks.forEach(link => link.remove());

    // Determine which theme to load
    const themeFile = mode === 'dark' ? 'github-dark.css' : 'github.css';
    
    // Create and append new stylesheet
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `https://cdnjs.cloudflare.com/ajax/libs/highlight.js/11.11.1/styles/${themeFile}`;
    link.setAttribute('data-highlight-theme', mode || 'light');
    document.head.appendChild(link);

    // Cleanup function
    return () => {
      const links = document.querySelectorAll('link[data-highlight-theme]');
      links.forEach(link => link.remove());
    };
  }, [mode]);

  return null;
}

